// assets/menu-accordion.js
document.addEventListener('DOMContentLoaded', function () {
  const menus = document.querySelectorAll('.menu.menu--accordion');

  if (!menus.length) return;

  menus.forEach(menu => {
    const parentButtons = menu.querySelectorAll('.menu__parent-heading');

    parentButtons.forEach((btn) => {
      const parent = btn.closest('.menu__item--parent');
      const sublist = parent.querySelector('.menu__sublist');

      if (!sublist) return;

      // init attributes
      btn.setAttribute('aria-expanded', 'false');
      sublist.setAttribute('aria-hidden', 'true');
      sublist.style.maxHeight = '0px';
      sublist.style.overflow = 'hidden';

      // toggle function
      const toggle = (open) => {
        if (open) {
          btn.setAttribute('aria-expanded', 'true');
          sublist.setAttribute('aria-hidden', 'false');
          parent.setAttribute('data-open', 'true');
          // set max-height for transition
          sublist.style.maxHeight = sublist.scrollHeight + 'px';
        } else {
          btn.setAttribute('aria-expanded', 'false');
          sublist.setAttribute('aria-hidden', 'true');
          parent.removeAttribute('data-open');
          sublist.style.maxHeight = null;
        }
      };

      // click handler
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        // close siblings
        const siblings = menu.querySelectorAll('.menu__item--parent');
        siblings.forEach(sib => {
          if (sib === parent) return;
          sib.removeAttribute('data-open');
          const sibBtn = sib.querySelector('.menu__parent-heading');
          const sibSub = sib.querySelector('.menu__sublist');
          if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
          if (sibSub) {
            sibSub.setAttribute('aria-hidden', 'true');
            sibSub.style.maxHeight = null;
          }
        });

        toggle(!isOpen);
      });

      // keyboard accessibility
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
        if (e.key === 'Escape') {
          btn.setAttribute('aria-expanded', 'false');
          sublist.setAttribute('aria-hidden', 'true');
          sublist.style.maxHeight = null;
        }
        if (e.key === 'ArrowDown') {
          const first = sublist.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
          if (first) {
            e.preventDefault();
            first.focus();
          }
        }
      });

      // close when a child link is clicked (improves UX)
      sublist.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', function () {
          toggle(false);
        });
      });

      // optional: close on resize to avoid stuck maxHeight values
      window.addEventListener('resize', function () {
        sublist.style.maxHeight = (sublist.getAttribute('aria-hidden') === 'true') ? null : sublist.scrollHeight + 'px';
      });
    });
  });
});
